// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__p35NO","logo":"PageHeader_logo__DvJlj"};